import React from 'react';
import img1 from './images/chooseImg1.jpg';
import img2 from './images/chooseImg2.jpg';
import img3 from './images/chooseImg3.jpg';

const Icon = ({ name }) => {
  const p = {
    width: 22, height: 22, viewBox: "0 0 24 24",
    fill: "none", stroke: "currentColor", strokeWidth: 1.7,
    strokeLinecap: "round", strokeLinejoin: "round"
  };

  switch (name) {
    case "suite":  // All-in-One WhatsApp Suite
      return (
        <svg {...p}>
          <rect x="3" y="3" width="7" height="7" rx="1" />
          <rect x="14" y="3" width="7" height="7" rx="1" />
          <rect x="14" y="14" width="7" height="7" rx="1" />
          <rect x="3" y="14" width="7" height="7" rx="1" />
        </svg>
      );
    case "engagement": // Faster Customer Engagement
      return (
        <svg {...p}>
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        </svg>
      );
    case "ai": // AI-Powered Personalization
      return (
        <svg {...p}>
          <circle cx="12" cy="12" r="9" />
          <path d="M9 10h.01M15 10h.01M8 15c1.333 1 2.667 1 4 0" />
        </svg>
      );
    case "secure": // Scalable & Secure
      return (
        <svg {...p}>
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        </svg>
      );
    default:
      return null;
  }
};

const WhyChoose = () => {
  return (
    <section
      className="py-5 position-relative why-bg"
      style={{ overflow: 'hidden' }}
    >
      <div
        className="px-5 x-xxl-5 px-6 mx-auto position-relative"
        style={{
          maxWidth: '74%',
          zIndex: 1,
          marginTop: 70
        }}
      >

        {/* GRID */}
        <div className="wc-grid">
          {/* LEFT images */}
          <div className="wc-left" aria-hidden="true">
            <div className="tile-grid" />
            <img className="wc-img top z2" src={img1} alt="" />
            <img className="wc-img mid z1" src={img2} alt="" />
            <img className="wc-img bot z1_5" src={img3} alt="" />
          </div>

          {/* RIGHT features */}
          <div className="wc-right">
            <h2
              style={{
                fontSize: "2.5rem",
                fontFamily: "Inter",
                fontWeight: 700,
                color: "#242121ff",
                lineHeight: 1.2,
              }}
            >
              Why Choose
              <span
                className="logo-h1"
                style={{
                  fontSize: "2.5rem",
                  fontFamily: "Poppins",
                  fontWeight: 600,
                  background: 'linear-gradient(90deg, #317cbeff 0%, #59C0FB 100%)',
                  WebkitBackgroundClip: 'text',
                  backgroundClip: 'text',
                  color: 'transparent',
                }}
              >
                {' '}Vertex Suite
              </span>
            </h2>
            <p
              className="mt-2"
              style={{
                marginTop: -2,
                color: "#413e3eff",
                fontSize: "1.1rem",
                fontFamily: "Poppins",
                fontWeight: 300,
                lineHeight: 1.2,
              }}
            >
              We know there are competitors in the market and winning the customer’s heart is
              possible only by answering “Why VertexSuite?” below are the answers for you,
            </p>

            <div className="wc-features">
              {[
                {
                  icon: 'suite',
                  title: 'All-in-One WhatsApp Suite',
                  desc: "Manage chatbots, campaigns, payments, and analytics- all in a single powerful platform."
                },
                {
                  icon: 'engagement',
                  title: 'Faster Customer Engagement',
                  desc: "Reduce response time and connect instantly with users through automated, real-time conversations."
                },
                {
                  icon: 'ai',
                  title: 'AI-Powered Personalization',
                  desc: "Deliver smart, personalized interactions that improve satisfaction and boost conversions."
                },
                {
                  icon: 'secure',
                  title: 'Scalable & Secure',
                  desc: "Enterprise-grade security and a platform that grows with your business, from startups to governments."
                }
              ].map((f, i) => (
                <div key={i} className="wc-item">
                  <div className="wc-icon"><Icon name={f.icon} /></div>
                  <div className="wc-shine" />
                  <div className="wc-title">{f.title}</div>
                  <div className="wc-desc">{f.desc}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .wc-grid{
          display:grid;
          grid-template-columns: 1.05fr 1fr;
          gap: 40px;
          align-items: center;
        }

        /* LEFT image cluster */
        .wc-left{ 
            position:relative; 
            min-height: 520px; 
            --imgW: 300px;
            --imgH: 230px;
        }
        .tile-grid{
          position:absolute; inset:0;
          border-radius: 22px;
          opacity:.45;
          background:
            radial-gradient( at 0 0, rgba(255,255,255,.12), transparent 60% ) 0 0 / 180px 140px,
            radial-gradient( at 100% 100%, rgba(255,255,255,.10), transparent 60% ) 90px 70px / 180px 140px;
        }

        .wc-img{
           position:absolute;
           display:block;
           object-fit:cover;
           background:#fff;
           border-radius:18px;
           transition:transform .3s ease;
           width: var(--imgW);
           height: var(--imgH);
        }

        .wc-img.top{ left:36%; top:8px; }
        .wc-img.mid{ left:32px; top:178px; border-radius:16px; }
        .wc-img.bot{ left:36%; top:330px; }

        .z2   { z-index: 30; }
        .z1   { z-index: 20; }
        .z1_5 { z-index: 10; }

        /* RIGHT features */
        .wc-features{
          display:grid;
          grid-template-columns: 1fr 1fr;
          gap: 28px 44px;
        }
        .wc-item{
          display:grid;
          grid-template-rows: auto 2px auto auto;
          row-gap: 10px;
        }
        .wc-icon{
          width:38px; height:38px; border-radius: 10px;
          display:flex; align-items:center; justify-content:center;
          color:#0a3f75; background: rgba(255,255,255,0.7);
          border:1px solid rgba(227,236,251,.9);
          backdrop-filter: blur(6px);
          -webkit-backdrop-filter: blur(6px);
        }
        .wc-shine{
          height:2px; border-radius:2px;
          background:
            linear-gradient(90deg, rgba(5,78,145,0) 0%,
                                   rgba(5,78,145,.45) 20%,
                                   rgba(5,78,145,.85) 50%,
                                   rgba(5,78,145,.45) 80%,
                                   rgba(5,78,145,0) 100%);
          position: relative; overflow: hidden;
        }
        .wc-shine::after{
          content:""; position:absolute; inset:-40% -10%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,.8), transparent);
          transform: translateX(-100%);
          animation: sweep 2.6s ease-in-out infinite;
        }
        @keyframes sweep { 
          0%{transform:translateX(-100%);} 
          50%{transform:translateX(0%);} 
          100%{transform:translateX(100%);} 
        }

        .wc-title{
          font-size: 18px;
          font-family: Lato;
          font-weight: 600;
          color: #242121ff;
          margin-top: 2px;
        }
        .wc-desc{
          margin-top: -3px;
          color:#64748b;
          font-size: 15px;
          font-weight: 400;
          font-family: Lato;
          line-height:1.35;
        }

        @media (max-width: 992px){
          .wc-left{ min-height: 460px; }
          .wc-img.top{ left: 40px; top: 0px; }
          .wc-img.mid{ left: 0px; top: 150px; }
          .wc-img.bot{ left: 120px; top: 260px; }
        }
      `}</style>
    </section>
  );
};

export default WhyChoose;
